import React from "react";
import SearchInput from "../search-input/SearchInput";
import LenderIdentificationSchema from "../../schemas/LenderIdentificationSchema";

const LenderIdentification = (props) => {
    const { lenderForm: { register, setValue, formState } } = props;
    const { lenderName, phoneNumber, email } = LenderIdentificationSchema;

    const setPhoneNumber = (e) => {
        e.preventDefault();
        const phNumberValue = e.target.value;

        let cleaned = ('' + phNumberValue).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
        if (match) {
            cleaned = `(${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}${match[4] ? ' x' : ''}${match[4]}`;
        }
        setValue(e.target.name, cleaned, { shouldValidate: true });
        return;
    }

    return (
        <React.Fragment>
            <div className="contract-heading">Lender Identification</div>
            <p className="contract-description">
                If you are a lender creating or updating a claim on behalf of the contract holder, please enter your information for tracking purposes.
            </p>
            <div className="mt-28">
                <SearchInput
                    label="Your Name"
                    placeholder="First & last name"
                    name="lenderName"
                    isRequired={true}
                    maxLength={45}
                    fieldRegister={register('lenderName', {
                        ...lenderName,
                        onChange: (e) => {
                            setValue(e.target.name, e.target.value.toUpperCase(), { shouldValidate: true })
                        }
                    })}
                    errorMessage={formState?.errors?.lenderName?.message || null}
                    {...props}
                />
            </div>
            <div className="mt-20">
                <SearchInput
                    label="Phone"
                    placeholder="10 digit phone number"
                    name="phoneNumber"
                    isRequired={true}
                    maxLength={20}
                    fieldRegister={register('phoneNumber', {
                        ...phoneNumber,
                        onChange: (e) => { setPhoneNumber(e) }
                    })}
                    errorMessage={formState?.errors?.phoneNumber?.message || null}
                    {...props}
                />
            </div>
            <div className="mt-20">
                <SearchInput
                    label="Email"
                    placeholder="Your email address"
                    name="email"
                    isRequired={true}
                    maxLength={50}
                    fieldRegister={register('email', {
                        ...email,
                        onChange: (e) => { setValue('email', e.target.value.trim().toUpperCase(), { shouldValidate: true }) }
                    })}
                    errorMessage={formState?.errors?.email?.message || null}
                    {...props}
                />
            </div>
        </React.Fragment>
    )
};

export default LenderIdentification;